export const getters = {
  getCurrentFeature: state => {
    return state.currentFeature
  },

  getCurrentFeatureChilds: state => {
    return state.currentFeatureChilds
  },

  getFeatures: state => {
    return state.features
  },

  getOrgLayers: state => {
    return state.orgLayers
  },


  getFeedFeatures: state => {
    return state.feedFeatures
  },

  getBeacons: state => {
    return state.beacons
  },
  getPlanetFeaturesEnabled: state => {
    return state.planetFeaturesEnabled
  },

  // Derive PlanetScope access from org member key settings; default to allowed when unknown
  getIsPlanetscopeAccess: (state, getters, rootState) => {
    if (state.planetFeaturesEnabled === true) {
      return true
    }

    const currentUserId = rootState?.user?.member?.member_id
    const currentOrg = rootState?.org?.current
    const orgMembers = rootState?.org?.currentMembers

    if (!currentUserId || !currentOrg) {
      // If we can't determine, don't block user
      return true
    }

    if (Array.isArray(orgMembers) && orgMembers.length) {
      const me = orgMembers.find(m => m.member_id === currentUserId)
      if (me && Array.isArray(me.key_settings) && me.key_settings.length) {
        const ks = me.key_settings
        const match = ks.find(k => {
          const name = (k?.name || '').toLowerCase()
          return name === 'planetscope' || name === 'planet scope'
        })
        if (match && typeof match.enabled === 'boolean') {
          return !!match.enabled
        }
      }
    }

    return true
  },

  getSelectedFeature: state => {
    return state.selected_feature
  },
  getSelectedTask: state => {
    return state.selected_task
  },

  getNotes: state => {
    return state.notes
  },

  getMap: state => {
    return state.map
  },
  getMap2: state => {
    return state.map2
  },
  getIsCompareMode: state => {
    return state.isCompareMode
  },
  getMapReady: state => {
    return state.mapReady
  },
  getMap2Ready: state => {
    return state.map2Ready
  },
  getDraw: state => {
    return state.draw
  },
  getTilesMosaics: state => {
    return state.tilesMosaics
  },
  getFiles: state => {
    return state.files
  },
  getLayers: state => {
    return state.layers
  },

  getIsMapReady: state => {
    return state.mapReady
  },

  getProjectReportTemplates: state => {
    return state.reportTemplates
  },

  getAllTemplates: state => {
    return state.allTemplates
  },

  getSystemTemplatesLibrary: state => {
    return state.systemTemplatesLibrary
  },

  getIsFeatureCreated: state => {
    return state.isFeatureCreated
  },
  getTotalOnMap: state => {
    return state.totalOnMap
  },

  isHeavyFeatureLoading: state => code => state.heavyFeatureLoading[code] === true,

  isHeavyFeatureLoaded: state => code => !!state.loadedHeavyGeometries[code],

  getFeatureVisibility: state => featureCode => {
    // Default to true (visible) if not explicitly set
    return state.featureVisibility[featureCode] !== false
  },

  getVisibleFeatures: state => {
    if (!state.features || !state.features.features) {
      return { type: 'FeatureCollection', features: [] }
    }
    
    const visibleFeatures = state.features.features.filter(feature => {
      const code = feature.properties?.code
      // Default to visible if not explicitly hidden
      return state.featureVisibility[code] !== false
    })
    
    return {
      type: 'FeatureCollection',
      features: visibleFeatures
    }
  },

  getVisibleFeedFeatures: state => {
    if (!state.feedFeatures || !state.feedFeatures.features) {
      return { type: 'FeatureCollection', features: [] }
    }
    
    const visibleFeatures = state.feedFeatures.features.filter(feature => {
      const code = feature.properties?.code
      // Default to visible if not explicitly hidden
      return state.featureVisibility[code] !== false
    })
    
    return {
      type: 'FeatureCollection',
      features: visibleFeatures
    }
  },

  getResources: state => {
    return state.resources || []
  },

  getResourcesByType: state => (type) => {
    if (!state.resources) return []
    return state.resources.filter(r => r.file_type === type)
  },

  getResourceById: state => (id) => {
    if (!state.resources) return null
    return state.resources.find(r => r.uuid === id || r.id === id)
  }
}
